import React from 'react';
import { HeaderWrapper } from './header.styled';
import logo from '../../assets/img/NewAvayaLogo.png';
import useConfig from  '../../hooks/config.hook';
import { useEngagementContext } from '../../contexts/engagement';
import { useToggleContext } from '../../contexts/toggle';
import { useNewMsgContext } from '../../contexts/msg';
import { useProcessingContext } from '../../contexts/processing';

function Header() {
   const engagementCtxt = useEngagementContext()
   const toggleCtx = useToggleContext();
   const msgContext = useNewMsgContext();
   const processingProvider = useProcessingContext()
   return (
      <HeaderWrapper>
         <header>
            <div className='logo'>
               <img width='140' src={useConfig().getMediaUrl(logo)} alt='AVAYA logo'></img>
            </div>
            <div className='header-buttons'>
               <button type='button' className='h-btn'><div className='neo-icon-minus'
               onClick={
                  () => {
                     toggleCtx.onClick()
                  }}   
               ></div></button>

            <button type='button' className={`h-btn btn-close ${toggleCtx.isLoading?"btn-disabled":""}`}
               onClick={
                     () => {
                        if (!toggleCtx.isLoading){
                           engagementCtxt.closeEngagement()
                           msgContext.clearDialog()
                           toggleCtx.onClick();
                           toggleCtx.resetCounterToggle();
                        }else{
                           toggleCtx.onClick();
                        }
                     }
                  }><div className='neo-icon-close'></div></button>
            </div>
         </header>
      </HeaderWrapper>
   )
};

export default Header;
